<template>
  <div class="error-view">
    <h1 class="error-view__code">{{ code }}</h1>
    <h2 v-if="title"
        class="error-view__title">{{ $t(title) }}</h2>
    <div class="error-view__text  text">
      <p>
        {{ computedMessage }}
      </p>
    </div>
    <div class="error-view__footer">
      <router-link :to="{name: 'home'}"
                   class="error-view__btn  base-btn  base-btn--blue">{{ $t('На головну') }}
      </router-link>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      code: {
        type: [String, Number],
        default: '404'
      },
      title: null,
      message: null
    },
    computed: {
      computedMessage() {
        return this.message || this.$t('Сторінку не знайдено. Неправильно набрано адресу або такої сторінки на сайті більше не існує')
      }
    }
  }
</script>

<style>

</style>
